import { Flex } from "@chakra-ui/react";
import { useHookstate } from "@hookstate/core";
import { ablyStore } from "../../hookstate/ablyStore";
import { MessageReaction } from "../chat/types";
import { ReactionTypeEntity } from "../../services/gc/types/reactionTypeEntity";
import { ReactionButton } from "./ReactionButton";

export function ReactionsRow({
  reactions,
  toggleReaction,
}: {
  reactions: Record<string, MessageReaction[]>;
  toggleReaction: (data: ReactionTypeEntity) => void;
}) {
  const realtimeClient = useHookstate(ablyStore.realtimeClient).get();

  return (
    <Flex gap="8px">
      {Object.values(reactions ?? {}).map((reactionsOfType, i) => {
        if (reactionsOfType.length === 0) return null;
        const userHasReacted = reactionsOfType.some(
          (reaction) => reaction.clientId === realtimeClient?.auth.clientId,
        );
        return (
          <ReactionButton
            key={i}
            toggleReaction={() => toggleReaction(reactionsOfType[0].reaction)}
            reactionTypeId={reactionsOfType[0].reaction.id}
            userHasReacted={userHasReacted}
            numberOfReactions={reactionsOfType.length}
          />
        );
      })}
    </Flex>
  );
}
